<span [class]="sizeClass + ' ' + weightClass">
  <span class="text-brand-orange">Trishna</span><span class="text-black">Wiki</span>
</span>